import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  AutoInvestmentsIcon,
  Box,
  ButtonResponsiveWrapper,
  useResponsive,
} from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { useHistory } from '@/modules/core/hooks';
import { useMyEnrollments } from '@/modules/transaction';

import { useSetupAutoInvestmentsModalStore } from '../stores';

import { useAutoInvestmentBanner } from './hooks';

// import { useAutoInvestment } from './hooks';
interface Props {
  isWideMode?: boolean;
  accountId?: string;
}

const AutoInvestmentBanner: React.FC<Props> = ({ isWideMode, accountId }) => {
  const { isMobile } = useResponsive();
  const { mainHSAEnrollment } = useMyEnrollments();
  const { t } = useTranslation();
  const { handleDismiss } = useAutoInvestmentBanner();
  const history = useHistory();
  const setModalVisible = useSetupAutoInvestmentsModalStore((state) => state.setVisible);

  const handleRedirect = useCallback(() => {
    history.push(`${ROUTES.INVESTMENTS}?id=${accountId || mainHSAEnrollment?.id}`);
    setModalVisible(true);
  }, [accountId, history, mainHSAEnrollment?.id, setModalVisible]);
  return (
    <>
      <Box data-testid="auto-investment-banner">
        <Banner
          isWideMode={isWideMode}
          title={t('Your Money. Your Future. On Autopilot.')}
          description={t(
            "Set it and forget it—no extra effort required. Set up regular transfers into your investment account, and we'll do the rest."
          )}
          icon={<AutoInvestmentsIcon />}
          testId="go-paperless"
        >
          <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
            <AppButton
              fill={isMobile}
              testId="auto-investment-banner_get-started"
              width="180px"
              onClick={handleRedirect}
            >
              {t('Get Started')}
            </AppButton>

            <AppButton
              fill={isMobile}
              testId="auto-investment-banner_cancel"
              buttonType="secondary"
              width="180px"
              onClick={handleDismiss}
            >
              {t('Dismiss')}
            </AppButton>
          </ButtonResponsiveWrapper>
        </Banner>
      </Box>
    </>
  );
};

export default AutoInvestmentBanner;
